import { ITransactionsTableFilter } from '../components/transactions-filters/transactions-table-filter.interface';
import { ICartViewFiltersFormValue } from '../models';

export const mapCartViewFiltersToBenefitExportFilters = (
  filters: ICartViewFiltersFormValue
): ITransactionsTableFilter => ({
  employeeId: parseCartViewEmployeeId(filters.employeeId),
  tenantId: filters.tenantId ?? undefined,
  benefitName: filters.benefitName || undefined,
  years: filters.years?.length ? filters.years : undefined,
  financingPlanType: filters.financingPlanType === '' ? null : filters.financingPlanType,
  withCancelled: filters.withCancelledCarts,
  cartStates: filters.cartStates?.length ? filters.cartStates : undefined,
});

const parseCartViewEmployeeId = (
  employeeId: string | number | null | undefined
): number | undefined => {
  if (employeeId === null || employeeId === undefined || employeeId === '') {
    return undefined;
  }

  const parsed = typeof employeeId === 'number' ? employeeId : Number(employeeId);

  return Number.isFinite(parsed) ? parsed : undefined;
};
